// Score colours (Appendix): 0.0 green #6CC287, 5.0 yellow #F2CE5B, 10.0 red #E0645A, shaded
// continuously. Chips use a pale tint of the hue with dark text of the same hue.

type Rgb = [number, number, number];
const GREEN: Rgb = [0x6c, 0xc2, 0x87];
const YELLOW: Rgb = [0xf2, 0xce, 0x5b];
const RED: Rgb = [0xe0, 0x64, 0x5a];
const CHIP_BG: [Rgb, Rgb, Rgb] = [
  [0xdf, 0xf2, 0xe3],
  [0xfc, 0xef, 0xc7],
  [0xfb, 0xe3, 0xe1],
];
const CHIP_INK: [Rgb, Rgb, Rgb] = [
  [0x1e, 0x6b, 0x3a],
  [0x7a, 0x56, 0x00],
  [0xa3, 0x21, 0x2d],
];

function mix(a: Rgb, b: Rgb, t: number): string {
  const c = a.map((v, i) => Math.round(v + (b[i]! - v) * t));
  return `#${c.map((v) => v.toString(16).padStart(2, '0')).join('')}`;
}

function along([a, b, c]: [Rgb, Rgb, Rgb], score: number): string {
  const s = Math.min(10, Math.max(0, score));
  return s <= 5 ? mix(a, b, s / 5) : mix(b, c, (s - 5) / 5);
}

export function scoreColour(score: number): string {
  return along([GREEN, YELLOW, RED], score);
}

export function chipColours(score: number | null): { background: string; color: string } {
  if (score === null) return { background: '#EEEAE2', color: '#57534C' };
  return { background: along(CHIP_BG, score), color: along(CHIP_INK, score) };
}
